import styled from 'styled-components'
import { motion } from 'framer-motion'
import { useTour } from '@reactour/tour'
import { colors } from '@/styles'

type Props = { title: string; subtitle: string; setIsOpen: any }

const StepTitle = styled.span`
  font-weight: 700;
  font-size: 16px;
`

const StepText = styled.span`
  font-size: 14px;
`

const StepWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  background: white;
  padding: 16px;
  border-radius: 6px;
  box-shadow: 0 0.5em 3em rgba(0, 0, 0, 0.3);
`

const Button = styled.button`
  display: flex;
  align-self: flex-end;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${colors.formAccent};
  background: ${colors.formAccent};
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.05);
  color: white;
  width: 74px;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${colors.blue24};
    box-shadow: 0px 6px 8px -2px rgba(29, 66, 94, 0.4), 0px 12px 16px rgba(32, 121, 193, 0.15);
  }
`

const Popover = ({ title, subtitle, setIsOpen }: Props) => {
  const { currentStep } = useTour()

  const clickIds = [
    'sllp-react-createlisting-gotit-click',
    'sllp-react-completelisting-gotit-click',
    'sllp-react-increaseinquiry-gotit-click',
    'sllp-react-selectlisting-gotit-click',
    'sllp-react-manageyoursl-gotit-click',
    'sllp-react-completelisting-gotit-click',
    'sllp-react-selectlisting-gotit-click',
    'sllp-react-manageyoursl-gotit-click',
    'sllp-react-publishlisting-gotit-click'
  ]

  const clickId = clickIds[currentStep]
  return (
    <StepWrapper initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
      <StepTitle>{title}</StepTitle>
      <StepText>{subtitle}</StepText>
      <Button onClick={() => setIsOpen(false)} id={clickId}>
        Got it
      </Button>
    </StepWrapper>
  )
}

export default Popover
